<template>
    <div v-if="date" :class="classes" @click="canBeSelected ? $emit('dateClicked', date) : ''">
            {{date.date.format('D')}}
        <div v-if="date.symbol" class="position-relative symbol-container"><i :class="'day-symbol ' + date.symbol"></i></div>
        <div class="mt-1 -ml-1 indicator-bar h-5 w-5 rounded-full sm:h-1 sm:w-8 sm:rounded-none"></div>
    </div>

    <div v-else class="calendar-day d-none"></div>
</template>

<script>
    export default {
        name: "calendar-day",
        props:['date', 'selectedDate', 'canSelectEmpty', 'canSelectOtherMonth', 'today', 'disablePastDays', 'noColorCoding'],
        computed: {
            isSelected() {
                return this.date.date.format('YYYY-MM-DD') === this.selectedDate.format('YYYY-MM-DD');
            },
            classes() {
                let classes = 'calendar-day flex-1';

                if((! this.noColorCoding) && this.canBeSelected && this.date.events.length > 0 && this.unBookedEvents.length < 1) {
                    classes += ' no-events has-pointer'
                }
                else if((! this.noColorCoding) && this.canBeSelected && this.date.events.length > 0 && this.unBookedEvents.length < 3) {
                    classes += ' few-events has-pointer'
                }
                else if(this.date.absence) {
                    classes += ' has-absence has-pointer';
                }
                else if(this.canBeSelected && this.date.events.length > 0) {
                    classes += ' has-events has-pointer';
                } else if(this.canSelectEmpty && (!this.date.otherMonth || this.canSelectOtherMonth)) {
                    classes += ' selectable-empty';
                }

                if(this.date.otherMonth) {
                    classes += ' other-month';
                }

                if(this.selectedDate &&  this.date.date.isSame(this.selectedDate, 'day')) {
                    classes += ' selected-date';
                }

                if(this.disablePastDays && this.date.date.diff(this.today) < 0) {
                    classes += ' past-day';
                }

                if (this.isSelected) {
                    classes += ' is-selected-date';
                }

                return classes;
            },
            unBookedEvents(){
                if(!this.date || !this.date.events.length) return [];

                return _.filter(this.date.events, function(event){
                    return !event.booking;
                });
            },
            canBeSelected(){
                return (this.date.events.length || this.canSelectEmpty) && (!this.date.otherMonth || this.canSelectOtherMonth);
            }
        },

    }
</script>

<style scoped>
    .is-selected-date {
        background-color: rgba(255, 255, 255, .25);
    }

    .symbol-container {
        padding-top: 5px;
    }
</style>
